import * as React from 'react';
import { Box, Dialog, DialogContent, Stack } from '@mui/material';
import { CTAButton, Subtitle, Title } from './confirmation.components';
import PartyImage from "../../../images/party.png"
import { Link } from 'react-router-dom';
import { internshipLink } from '../../../common/routes';

export default function Confirmation({ open }) {
    return (
        <div>
            <Dialog
                open={open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{ bgcolor: "grey" }}
            >
                <DialogContent>
                    <Stack
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        spacing={3.75}
                    >
                        <Box component="img" src={PartyImage} alt="" sx={{
                            width: 129,
                            height: 129
                        }} />
                        <Box>
                            <Title>Your submission is complete!</Title>
                            <Subtitle>You will recieve a confirmation email with order detail </Subtitle>
                        </Box>
                        <Stack
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            spacing={2.5}
                        >
                            <CTAButton onClick={() => { window.location.reload(false) }}>Dashboard</CTAButton>
                            <CTAButton component={Link} to={internshipLink}>Explore More </CTAButton>
                        </Stack>
                    </Stack>
                </DialogContent>
            </Dialog>
        </div>
    );
}
